import zhLocale from "element-ui/lib/locale/lang/zh-CN"; //引入element语言包
//需要转换的中文
const zh_CN = {
  message: {
    info: {
      n1: "验证码登录",
      n2: "邮箱",
      n3: "请输入邮箱",
      n4: "验证码",
      n5: "请输入验证码",
      n6: "获取验证码",
      n7: "登 录",
      n8: "注册",
      n9: "密码登录",
      n10: "密码",
      n11: "请输入密码",
      n12: "邮箱错误",
      n13: "验证码已发送",
      n14: "新密码",
      n15: "确 定",
      n16: "修改密码",
      n17: "退出登录",
      n18: "首页",
      n19: "海外短信",
      n20: "短信内容",
      n21: "发送记录",
      n22: "余额：",
      n23: "余额明细",
      n24: "操作前余额",
      n25: "操作余额",
      n26: "操作后余额",
      n27: "业务类型",
      n28: "充值",
      n29: "消费",
      n30: "退款",
      n31: "变动类型",
      n32: "增加",
      n33: "减少",
      n34: "备注",
      n35: "操作时间",
      n36: "短信价格",
      n37: "区号",
      n38: "区域名称",
      n39: "价格",
      n40: "激活状态",
      n41: "可用",
      n42: "不可用",
      n43: "更新时间",
      n44: "短信列表",
      n45: "请选择发送状态",
      n46: "待发送",
      n47: "发送中",
      n48: "已完成",
      n49: "待确认",
      n50: "请选择审核状态",
      n51: "待审核",
      n52: "审核通过",
      n53: "审核拒绝",
      n54: "搜索",
      n55: "重置",
      n56: "新增",
      n57: "内容ID",
      n58: "短信内容",
      n59: "号码总数",
      n60: "成功数",
      n61: "失败数",
      n62: "发送状态",
      n63: "审核",
      n64: "发送开始时间",
      n65: "发送结束时间",
      n66: "操作",
      n67: "导入号码",
      n68: "导入完成",
      n69: "删除",
      n70: "添加短信内容",
      n71: "请输入内容最多500字",
      n72: "注：短信内容将直接发送给用户，请确认无敏感信息",
      n73: "取 消",
      n74: "导入手机号码",
      n75: "收信人",
      n76: "导入收信人",
      n77: "添加收信人",
      n78: "请下载模板文件，按照模板格式填写手机号码后上传",
      n79: "下载模板",
      n80: "支持 .xlsx, .xls, .csv 格式",
      n81: "将文件拖到此处，或",
      n82: "点击上传",
      n83: "单次最多上传1个文件，文件大小不超过5MB",
      n84: "请选择",
      n85: "请输入内容",
      n86: "添加更多号码",
      n87: "只能上传",
      n88: "格式的文件",
      n89: "文件大小不能超过",
      n90: "确定要删除吗？",
      n91: "提示",
      n92: "发送列表",
      n93: "请输入短信内容ID",
      n94: "请选择区号",
      n95: "请输入接收手机号",
      n96: "请选择状态",
      n97: "待发送",
      n98: "发送中",
      n99: "成功",
      n100: "失败",
      n101: "区号",
      n102: "接收手机号",
      n103: "消耗金额",
      n104: "请再次输入密码",
      n105: "两次密码不一致",
      n106: "新密码",

      n107: "请输入关键字",
      n108: "请输入谷歌秘钥",
      n109: "添加",
      n110: "关键词",
      n111: "经度",
      n112: "纬度",
      n113: "修改",
      n114: "新增",
      n115: "谷歌秘钥：",
      n116: "条数",
      n117: "名称",
      n118: "地址",
      n119: "电话",
      n120: "创建时间",
      n121: "数据查看",
      n122: "下载",
      n123: "采集中",
      n124: "成功",
      n125: "失败",
      n126: "状态",
      n127: "谷歌采集",
      n128: "请输入内容",
      n129: "请选择坐标",
      n130: "选点",
      n131: "查看",
      n132: "中心位置",
      n133: "确 定",
      n134: "选择地图位置",
      n135: "搜索地点",
      n136: "当前选中坐标",
      n137: "请输入搜索关键词",
      n138: "请选择中心位置",
      n139: "未找到该地点，请尝试其他关键词",
      n140: "请先在地图上选择一个位置",
      n141: "下载失败",
      n142: "下载成功",
      n143: "下载请求失败",
      n144: "",
      n145: "",
      n146: "",
      n147: "",
      n148: "",
      n149: "",
      n150: "",
      n151: "",
      n152: "",
      n153: "",
      n154: "",
      n155: "",
      n156: "",
      n157: "",
      n158: "",
      n159: "",
      n160: "",
      n161: "",
      n162: "",
      n163: "",
      n164: "",
      n165: "",
      n166: ""
    }
  },
  ...zhLocale
};
export default zh_CN;



// WEBPACK FOOTER //
// ./src/assets/i18n/langs/zh_CN.js